import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import { AppIntlProvider } from 'translation/intl-provider';
import { UserProvider } from 'features/user/contexts/user-provider';
import App from './App';
import {Web3Provider} from '@ethersproject/providers';
import { Web3ReactProvider } from '@web3-react/core';

const root = ReactDOMClient.createRoot(document.getElementById('root'));

root.render(
  <AppIntlProvider>
    <UserProvider>
      <Web3ReactProvider getLibrary={provider => new Web3Provider(provider)}>
        <App />
      </Web3ReactProvider>
    </UserProvider>
  </AppIntlProvider>,
);
